import { render, staticRenderFns } from "./EditClientModal.vue?vue&type=template&id=7f345ea2&"
import script from "./EditClientModal.vue?vue&type=script&lang=js&"
export * from "./EditClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports